import React, { useState, useEffect } from "react";
import { Typography } from "@material-ui/core";
import PWDRequisite from "../../general/PWDRequisite";
import { Stepper, Step } from "react-form-stepper";
import { toast } from "react-toastify";
import Modal from "react-modal";
import Loader3Orange from "../../general/Loader3Orange";
import { MdDescription } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import StepWizard from "react-step-wizard";
import * as theme from "../../theme";
import { getProvinceInformation } from "../../store/broker";
import Select from "react-dropdown-select";
import Payment from "./Payment";
import CancelIcon from "@material-ui/icons/Cancel";
import { getBrokerageInformation } from "../../store/brokerage";
import { loginModalClosed, signUpModalClosed } from "../../store/components";
import { useForm } from "react-hook-form";
import {
  existingBrokrage,
  getExistingBrokerage,
  existingBrokrageInitialize,
  existingBrokrageFailed,
} from "../../store/broker";
import "./signup.css";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormFeedback,
  Label,
  Input,
} from "reactstrap";

import BootstrapButton from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";

import PerfectScrollbar from "react-perfect-scrollbar";
const ActionButtons = (props) => {
  const dispatch = useDispatch();
  const brokerData = useSelector(getExistingBrokerage);
  const brokeCode = useSelector(existingBrokrageInitialize);
  const brokeFailed = useSelector(existingBrokrageFailed);
  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleBack = () => {
    props.previousStep();
  };
  //api caling

  const handleNext = () => {
    props.nextStep();
  };
  const newBrokerageDetails = {
    name: props.user?.name,
    code: props.user?.code,
    address: [
      {
        city: props.user?.city,
        addr_line1: props.user?.addr1,
        addr_line2: props.user?.addr2,
        postal_code: props.user?.postalCode,
        province: props.user?.province,
      },
    ],
    contact: props.user?.phone,
    website: props.user?.website,
    contact_number: +props.user?.userPhoneNumber,
    username: props.user?.userName,
    role: props.user?.userRole,
    password: props.user?.userPassword,
    email: props.user?.userEmail,
    token: props.user?.token?.id,
  };

  const handleSignUp = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BASICSERVICE}/api/brokerages/signup-now`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("jwt"),
        },
        body: JSON.stringify({
          newBrokerageDetails,
          frontEndOrigin: window.location.origin,
        }),
      }
    );
    const signUp = await response.json();

    if (response.ok) {
      setIsLoading(false);
      toast.success(signUp.message);
      await setModalOpen(true);
    } else {
      toast.success(signUp.message);
    }
  };
  return (
    <div>
      {isLoading ? <Loader3Orange /> : null}
      <div>
        <Modal
          isOpen={modalOpen}
          ariaHideApp={false}
          shouldCloseOnEsc={false}
          style={{
            overlay: {
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: theme.COLORS.rgba_primary_navyblue,
            },
            content: {
              height: "20%",
              width: "40%",
              position: "absolute",
              margin: "0 auto",
              top: "7vh",
              left: "-1vw",
              right: 0,
              bottom: 0,
              background: theme.COLORS.tertiary_lightbackground,
              WebkitOverflowScrolling: "touch",
              border: "8px solid " + theme.COLORS.primary_navyblue,
              borderRadius: "20px",
              padding: 0,
              overflow: "hidden",
            },
          }}
        >
          <PerfectScrollbar>
            <div>
              <div style={{ position: "absolute", top: 5, right: 5 }}>
                <CancelIcon
                  fontSize="large"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setModalOpen(false);
                    dispatch(signUpModalClosed());
                    dispatch(loginModalClosed());
                  }}
                ></CancelIcon>
              </div>
              <div className="container-fluid">
                <p className="text-secondary" style={{ paddingTop: "44px" }}>
                  Thank you for completing this information and signing up to
                  Quotey. We’re excited to have you on board! Please check your
                  inbox as we’ve sent you an email to confirm your address with
                  a link to complete the process. We also recommend checking
                  your junk folder if you don’t see it in your inbox.
                </p>
              </div>
            </div>
          </PerfectScrollbar>
        </Modal>
      </div>
      <Row>
        {props.currentStep > 1 && (
          <Col>
            <Button
              style={{
                backgroundColor: theme.COLORS.secondary_orange,
              }}
              onClick={handleBack}
            >
              Back
            </Button>
          </Col>
        )}
        <Col>
          {props.currentStep < props.totalSteps && (
            <Button
              className=""
              style={{
                backgroundColor: theme.COLORS.secondary_orange,
                marginLeft: "85%",
              }}
              onClick={() => {
                handleNext();
              }}
            >
              Next
            </Button>
          )}
          {props.currentStep === props.totalSteps && (
            <Button
              style={{
                backgroundColor: theme.COLORS.secondary_orange,
                marginLeft: "85%",
              }}
              onClick={() => {
                setIsLoading(true);
                handleSignUp();
              }}
            >
              Finish
            </Button>
          )}
        </Col>
      </Row>
    </div>
  );
};

const One = (props) => {
  const dispatch = useDispatch();
  const provinces = useSelector(getProvinceInformation);
  const languageSelected = props.languageSelected;

  useEffect(() => {
    if (provinces) {
      setProvinceValue(provinces.provinces);
    }
  }, [provinces]);
  const [info1, setInfo1] = useState({});
  const [error, setError] = useState("");
  const [formIdError, setFormIdError] = useState(false);
  const [nameError, setNameError] = useState("");
  const [provinceError, setProvinceError] = useState("");
  ////
  const [state, setState] = useState(false);
  const [provinceValue, setProvinceValue] = useState([]);
  const [name, setName] = useState(null);
  const [code, setCode] = useState(null);
  const [addr1, setAddr1] = useState(null);
  const [addr2, setAddr2] = useState(null);
  const [city, setCity] = useState(null);
  const [province, setProvince] = useState(null);
  const [postalCode, setPostalCode] = useState(null);
  const [website, setWebsite] = useState(null);
  const [phone, setPhone] = useState(null);

  const brokarageDetails = {
    name: name,
    code: code,
    addr1: addr1,
    addr2: addr2,
    city: city,
    province: province,
    postalCode: postalCode,
    website: website,
    phone: phone,
  };

  const translations = {
    en: {
      welcome:
        "Welcome to Quotey! In order to set your brokerage up, we’ll need some basic details about the brokerage, about yourself, and a payment card for the first and ongoing payments. Once this is completed, you’ll receive an email where you can go to Quotey, set up your team and start transforming your business.",
      brokerageName: "Brokerage Name (as it should appear in documents)",
      addressLine1: "Address Line 1",
      addressLine2: "Address Line 2",
      city: "City",
      province: "Province",
      postalCode: "Postal Code",
      website: "Website",
      phoneNumber: "Brokerage Phone Number",
    },
    fr: {
      welcome:
        "Bienvenue chez Quotey ! Pour configurer votre cabinet, nous aurons besoin de quelques détails de base sur le cabinet, sur vous-même et une carte de paiement pour les premiers paiements et les paiements continus. Une fois cela terminé, vous recevrez un courriel où vous pourrez aller à Quotey, configurer votre équipe et commencer à transformer votre entreprise.",
      brokerageName:
        "Nom du cabinet (tel qu'il doit apparaître dans les documents)",
      addressLine1: "Adresse Ligne 1",
      addressLine2: "Adresse Ligne 2",
      city: "Ville",
      province: "Province",
      postalCode: "Code Postal",
      website: "Site Web",
      phoneNumber: "Numéro de téléphone du cabinet",
    },
  };

  const onProvinceHandle = (value) => {
    setProvinceError("");
    setProvince(value[0].code);
  };
  const handleCheckCode = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BASICSERVICE}/api/brokerages/get-exitsting-brokerage`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("jwt"),
        },
        body: JSON.stringify({ code: code }),
      }
    );
    const codeMessage = await response.json();
    if (response.ok) {
      setNameError("");
      setProvinceError("");
      props.userCallback(brokarageDetails);
      props.nextStep();
    } else {
      toast.success(codeMessage.message);
    }
  };
  const validate = () => {
    if (!name) {
      setNameError("brokrage name is required");
    }
    if (!province) {
      setProvinceError("province field is required");
    }
    if (name && province) {
      handleCheckCode();
      setNameError("");
      setProvinceError("");
    }
  };

  return (
    <div className="container-fluid">
      <div className="px-3">
        <p
          className="text-secondary"
          style={{
            fontSize: "1rem",
            marginBottom: "3%",
            paddingTop: "2%",
          }}
        >
          {translations[languageSelected].welcome}
        </p>
      </div>
      <div className="form ">
        <form>
          <div className="row">
            <div className="col-6 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-12">
              <div style={{ verticalAlign: "middle" }}>
                <FormGroup className="ml-3">
                  <Label className="form-label">
                    {translations[languageSelected].brokerageName}
                    <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    required
                    className="col-sm-10"
                    type="text"
                    name="brokerageName"
                    placeholder="Enter The Name Of Your Brokerage"
                    onChange={(event) => {
                      setName(event.target.value);
                      setNameError("");
                      setCode(
                        event.target.value
                          .replaceAll(" ", "")
                          .replace(/[^a-zA-Z0-9 ]/g, "")
                          .toUpperCase()
                      );
                    }}
                  />
                  {nameError ? (
                    <span className="text-danger">{nameError}</span>
                  ) : null}
                </FormGroup>
                <FormGroup className="ml-3">
                  <Label className="form-label">
                    {translations[languageSelected].addressLine1}
                  </Label>
                  <Input
                    className="col-sm-10 "
                    type="text"
                    name=" Address Line 1"
                    placeholder="Enter Address Line 1"
                    onChange={(event) => {
                      setAddr1(event.target.value);
                    }}
                    defaultValue={addr1}
                  />
                </FormGroup>
                <FormGroup className="ml-3">
                  <Label className="form-label">
                    {translations[languageSelected].addressLine2}
                  </Label>
                  <Input
                    className="col-sm-10"
                    type="text"
                    name={translations[languageSelected].addressLine2}
                    placeholder="Enter Address Line 2"
                    onChange={(event) => {
                      setAddr2(event.target.value);
                    }}
                    defaultValue={addr2}
                  />
                </FormGroup>
                <FormGroup className="ml-3">
                  <Label className="form-label">
                    {translations[languageSelected].city}{" "}
                  </Label>
                  <Input
                    className="col-sm-10"
                    type="text"
                    name=" city"
                    placeholder="Enter City"
                    onChange={(event) => {
                      setCity(event.target.value);
                    }}
                  />
                </FormGroup>
              </div>
            </div>
            <div className="col-6 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-12">
              <div style={{ verticalAlign: "middle" }}>
                <FormGroup className="ml-3">
                  <Label className="form-label">
                    {translations[languageSelected].province}{" "}
                    <span style={{ color: "red" }}>*</span>{" "}
                  </Label>
                  <Select
                    placeholder={"Select Province"}
                    color={theme.COLORS.primary_navyblue}
                    searchable={true}
                    onChange={(values) => onProvinceHandle(values)}
                    values={[]}
                    options={provinceValue}
                    style={{
                      width: "100%",
                      height: "5vh",
                      fontSize: "1.9vmin",
                      border: "5px solid white",
                      borderRadius: 15,
                      fontFamily: "GibsonRegular",
                    }}
                    className="col-sm-10"
                    labelField={"name"}
                    valueField={"code"}
                    dropdownHeight={"58vh"}
                  />
                  {provinceError ? (
                    <span className="text-danger">{provinceError}</span>
                  ) : null}
                </FormGroup>
                <FormGroup className="ml-3">
                  <Label className="form-label">
                    {translations[languageSelected].postalCode}
                  </Label>
                  <Input
                    className="col-sm-10"
                    type="text"
                    name="postalCode"
                    placeholder="Enter Postal Code"
                    onChange={(event) => {
                      setPostalCode(event.target.value);
                    }}
                    defaultValue={postalCode}
                  />
                </FormGroup>

                <FormGroup className="ml-3">
                  <Label className="form-label">
                    {translations[languageSelected].website}{" "}
                  </Label>
                  <Input
                    className="col-sm-10"
                    type="text"
                    name="Website"
                    placeholder="Enter Website"
                    onChange={(event) => {
                      setWebsite(event.target.value);
                    }}
                    defaultValue={website}
                  />
                </FormGroup>

                <FormGroup className="ml-3">
                  <Label className="form-label">
                    {translations[languageSelected].phoneNumber}
                  </Label>
                  <Input
                    className="col-sm-10"
                    type="text"
                    name="Phone"
                    placeholder="Enter Brokerage Phone Number"
                    onChange={(event) => {
                      setPhone(event.target.value);
                    }}
                    defaultValue={phone}
                  />
                </FormGroup>
              </div>
            </div>
          </div>
        </form>
      </div>
      <br />
      <ActionButtons {...props} nextStep={validate} code={code} />
    </div>
  );
};

const Two = (props) => {
  const languageSelected = props.languageSelected;
  const [info2, setInfo2] = useState({});
  const [error, setError] = useState("");
  const [userNameError, setUserNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [confirmEmailError, setConfirmEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const [isValid, setIsValid] = useState(false);
  const [message, setMessage] = useState("");
  const [emailMessage, setEmailMessage] = useState("");
  const [passwordMessage, setPasswordMessage] = useState("");
  const [pwdRequisite, setPWDRequisite] = useState(false);
  const [checks, setChecks] = useState({
    capsLetterCheck: false,
    numberCheck: false,
    pwdLengthCheck: false,
    specialCharCheck: false,
  });
  ////
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState(null);
  const [confirmEmail, setConfirmEmail] = useState(null);
  const [userPhone, setUserPhone] = useState(null);
  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [location, setLocation] = useState(null);
  const [role, setJobRole] = useState(null);
  // const [bio, setBio] = useState(null);
  const userDetails = {
    userName: user,
    userEmail: email,
    userPassword: password,
    userRole: role,
    userPhoneNumber: userPhone,
  };

  const translations = {
    en: {
      tellUsAboutYourself:
        "Now please tell us about yourself and set up your password.",
      yourName: "Your name",
      email: "Email",
      confirmEmail: "Confirm Email",
      contactPhoneNumber: "Contact Phone Number",
      roleJobTitle: "Role/ Job Title",
      password: "Password",
      confirmPassword: "Confirm Password",
      enterName: "Enter Name",
      enterEmail: "Enter Email",
      enterConfirmEmail: "Enter Confirm Email",
      enterContactPhoneNumber: "Enter Contact Phone Number",
      enterRoleJobTitle: "Enter Role/ Job Title",
      enterPassword: "Enter Password",
      enterConfirmPassword: "Enter Confirm Password",
      examplePassword: "Example: Test@!#123",
    },
    fr: {
      tellUsAboutYourself:
        "Veuillez maintenant nous parler de vous et configurer votre mot de passe.",
      yourName: "Votre nom",
      email: "E-mail",
      confirmEmail: "Confirmer l'E-mail",
      contactPhoneNumber: "Numéro de téléphone de contact",
      roleJobTitle: "Rôle/ Titre du poste",
      password: "Mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      enterName: "Entrez le nom",
      enterEmail: "Entrez l'E-mail",
      enterConfirmEmail: "Entrez la confirmation de l'E-mail",
      enterContactPhoneNumber: "Entrez le numéro de téléphone de contact",
      enterRoleJobTitle: "Entrez le rôle/ titre du poste",
      enterPassword: "Entrez le mot de passe",
      enterConfirmPassword: "Entrez la confirmation du mot de passe",
      examplePassword: "Exemple : Test@!#123",
    },
  };
  const handleCheckUser = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BASICSERVICE}/api/brokerages/get-exitsting-user`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("jwt"),
        },
        body: JSON.stringify({ email: email }),
      }
    );
    const codeMessage = await response.json();
    if (response.ok) {
      props.nextStep();
      props.userCallback(userDetails);
      setUserNameError("");
      setPasswordError("");
      setEmailError("");
    } else {
      toast.success(codeMessage.message);
    }
  };
  const handleChangeConformEmail = (event) => {
    const emailConf = event.target.value;
    setConfirmEmail(event.target.value);
    if (email != emailConf) {
      setConfirmEmailError("Confirm Email Should be match with Email");
    } else {
      setConfirmEmailError("");
    }
  };
  const handlePasswordChange = (event) => {
    setPasswordError("");
    setPassword(event.target.value);
    const pass = event.target.value;
    if (pass != confirmPassword) {
      setConfirmPasswordError("Confirm Password Should be match with Password");
    } else {
      setConfirmPasswordError("");
    }
  };
  const handleOnFocus = () => {
    setPWDRequisite(true);
  };
  const handleOnBlur = () => {
    setPWDRequisite(false);
  };
  const handleOnKeyUp = (e) => {
    const { value } = e.target;
    const capsLetterCheck = /[A-Z]/.test(value);
    const numberCheck = /[0-9]/.test(value);
    const pwdLengthCheck = value.length >= 8;
    const specialCharCheck = /[.!@#$%^&*()_+-=]/.test(value);
    setChecks({
      capsLetterCheck,
      numberCheck,
      pwdLengthCheck,
      specialCharCheck,
    });
  };
  const handleChangeConfirmPassword = (event) => {
    const checkConfirm = event.target.value;
    setConfirmPassword(event.target.value);
    if (password != checkConfirm) {
      setConfirmPasswordError("Confirm Password Should be match with Password");
    } else {
      setConfirmPasswordError("");
    }
  };

  const validateEmail = (event) => {
    const emailRegex = /\S+@\S+\.\S+/;
    const emailVal = event.target.value;
    if (emailVal != confirmEmail) {
      setConfirmEmailError("Confirm Email Should be match with Email");
    } else {
      setConfirmEmailError("");
    }

    setEmail(event.target.value);
    setEmailError("");
    if (emailRegex.test(emailVal)) {
      setEmailMessage("Your email looks good!");
      setMessage("");
    } else {
      setEmailMessage("");

      setMessage("Please enter a valid email!");
    }
  };

  const validate2 = () => {
    const emailRegex = /\S+@\S+\.\S+/;
    if (!confirmEmail) {
      setConfirmEmailError(true);
    }
    if (!user) {
      setUserNameError("UserName is Required");
    }

    if (!password) {
      setPasswordError("Password is Required");
    }
    if (!email) {
      setEmailError("Email Field is Required");
      setMessage("");
    }
    if (
      user &&
      password &&
      email &&
      confirmEmail &&
      emailRegex.test(email) &&
      email === confirmEmail &&
      password === confirmPassword
    ) {
      handleCheckUser();
      setIsValid(false);
      setConfirmEmailError(false);
      setConfirmPasswordError(false);
    }
  };

  return (
    <div className="container-fluid">
      <div
        style={{
          fontFamily: "GibsonRegular",
        }}
      >
        <div className="px-3">
          <p
            className="text-secondary"
            style={{
              fontSize: "1rem",
              marginBottom: "3%",
              paddingTop: "2%",
            }}
          >
            {translations[languageSelected].tellUsAboutYourself}
          </p>
        </div>
        <div className="row">
          <div className="col-6 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-12">
            <div style={{ verticalAlign: "middle" }}>
              <FormGroup className="ml-3">
                <Label className="form-label">
                  {translations[languageSelected].yourName}{" "}
                  <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  className="col-sm-10"
                  type="text"
                  name="name"
                  placeholder={translations[languageSelected].enterName}
                  onChange={(event) => {
                    setUserNameError("");
                    setUser(event.target.value);
                  }}
                  defaultValue={user}
                />
                {userNameError ? (
                  <span className="text-danger">{userNameError}</span>
                ) : null}
              </FormGroup>
              <FormGroup className="ml-3">
                <Label className="form-label">
                  {translations[languageSelected].email}{" "}
                  <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  className="col-sm-10"
                  type="text"
                  name="email"
                  placeholder="Enter Email"
                  onChange={(event) => {
                    validateEmail(event);
                  }}
                  defaultValue={email}
                />
                {message ? (
                  <span className="text-danger">{message}</span>
                ) : null}
                {emailMessage ? (
                  <span className="text-success">{emailMessage}</span>
                ) : null}
                {emailError ? (
                  <span className="text-danger">{emailError}</span>
                ) : null}
              </FormGroup>
              <FormGroup className="ml-3">
                <Label className="form-label">
                  {translations[languageSelected].confirmEmail}{" "}
                  <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  className="col-sm-10"
                  type="text"
                  name="confirmEmail"
                  placeholder={translations[languageSelected].enterConfirmEmail}
                  onChange={(event) => {
                    handleChangeConformEmail(event);
                  }}
                  defaultValue={confirmEmail}
                />
                <span className="text-danger">{confirmEmailError}</span>
              </FormGroup>
              <FormGroup className="ml-3">
                <Label className="form-label">
                  {" "}
                  {translations[languageSelected].contactPhoneNumber}{" "}
                </Label>
                <Input
                  className="col-sm-10"
                  type="text"
                  name="userPhone"
                  placeholder={
                    translations[languageSelected].enterContactPhoneNumber
                  }
                  onChange={(event) => {
                    setUserPhone(event.target.value);
                  }}
                  defaultValue={userPhone}
                />
              </FormGroup>
            </div>
          </div>
          <div className="col-6 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-12">
            <div style={{ verticalAlign: "middle" }}>
              <FormGroup className="ml-3">
                <Label className="form-label">
                  {translations[languageSelected].roleJobTitle}
                </Label>
                <Input
                  className="col-sm-10"
                  type="text"
                  name="role"
                  placeholder={translations[languageSelected].enterRoleJobTitle}
                  onChange={(event) => {
                    setJobRole(event.target.value);
                  }}
                  defaultValue={role}
                />
              </FormGroup>
              <FormGroup className="ml-3">
                <Label className="form-label">
                  {translations[languageSelected].password}{" "}
                  <span style={{ color: "red" }}>*</span>
                  <small className="text-primary">
                    {translations[languageSelected].examplePassword}
                  </small>
                </Label>
                <Input
                  className="col-sm-10 "
                  type="password"
                  name="password"
                  placeholder={translations[languageSelected].enterPassword}
                  onChange={(event) => {
                    handlePasswordChange(event);
                  }}
                  onFocus={handleOnFocus}
                  onBlur={handleOnBlur}
                  onKeyUp={(e) => handleOnKeyUp(e)}
                  defaultValue={password}
                />
                {passwordError ? (
                  <span className="text-danger">{passwordError}</span>
                ) : null}
                <div className="cardLeble">
                  {pwdRequisite ? (
                    <PWDRequisite
                      capsLetterFlag={
                        checks.capsLetterCheck ? "valid" : "invalid"
                      }
                      numberFlag={checks.numberCheck ? "valid" : "invalid"}
                      pwdLengthFlag={
                        checks.pwdLengthCheck ? "valid" : "invalid"
                      }
                      specialCharFlag={
                        checks.specialCharCheck ? "valid" : "invalid"
                      }
                    />
                  ) : null}
                </div>
              </FormGroup>
              <FormGroup className="ml-3">
                <Label className="form-label">
                  {translations[languageSelected].confirmPassword}{" "}
                  <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  className="col-sm-10"
                  type="password"
                  name="password"
                  placeholder={
                    translations[languageSelected].enterConfirmPassword
                  }
                  onChange={(event) => {
                    handleChangeConfirmPassword(event);
                  }}
                  defaultValue={confirmPassword}
                />
                <span className="text-danger">{confirmPasswordError}</span>
              </FormGroup>
            </div>
          </div>
        </div>
      </div>
      <br />
      <ActionButtons {...props} nextStep={validate2} />
    </div>
  );
};

const Three = (props) => {
  const translations = {
    en: {
      digitalMasterServicesAgreement: "Digital Master Services Agreement",
      setupBrokerageText:
        "In order to set your brokerage up for Quotey, you will need to confirm agreement to our Master Services Agreement.",
      masterServicesAgreement: "Master Services Agreement",
    },
    fr: {
      digitalMasterServicesAgreement:
        "Accord Principal des Services Numériques",
      setupBrokerageText:
        "Pour configurer votre cabinet pour Quotey, vous devrez confirmer l'accord de notre Accord Principal des Services.",
      masterServicesAgreement: "Accord Principal des Services",
    },
  };

  const [scrollCheck, setScrollCheck] = useState(false);
  const languageSelected = props.languageSelected;
  const validate3 = () => {
    if (scrollCheck === true) {
      props.nextStep();
      props.userCallback({ check: scrollCheck });
    } else {
      toast.success("Please Check Terms & Condition ");
    }
  };

  return (
    <div className="container-fluid px-5">
      <dt className="py-3 ">
        {translations[languageSelected].digitalMasterServicesAgreement}
      </dt>
      <h6 className="text-secondary">
        {translations[languageSelected].setupBrokerageText}
      </h6>
      <div className="mt-2 mb-4">
        <span className="text-primary fw-bold" style={{ fontWeight: "bold" }}>
          {translations[languageSelected].masterServicesAgreement}
        </span>
      </div>

      <div
        className="border border-secondary border-3"
        style={{
          width: "98%",
          height: "350px",
        }}
      >
        <PerfectScrollbar>
          <div
            className="px-3 py-0 text-secondary bg-white "
            // style={{ fontFamily: "sans-serif" }}
          >
            <div class="WordSection1">
              <p class="Paragraph" style={{ textAlign: "justify" }}>
                <span lang="EN-CA">&nbsp;</span>
              </p>

              <p class="Paragraph" style={{ textAlign: "justify" }}>
                <span lang="EN-CA">
                  This Digital Services Agreement (this "<b>Agreement</b>") is a
                  binding contract between you ("<b>Customer</b>", "<b>you</b>",
                  or "<b>your</b>") and Quotey Inc. ("<b>Provider</b>", "
                  <b>we</b>", or "<b>us</b>"). This Agreement governs your
                  access to and use of the Digital Services.{" "}
                </span>
              </p>
              <p class="Paragraph" style={{ textAlign: "justify" }}>
                <span lang="EN-CA">
                  THIS AGREEMENT TAKES EFFECT WHEN YOU CLICK THE "I ACCEPT"
                  BUTTON BELOW OR BY ACCESSING OR USING THE DIGITAL SERVICES
                  (the "<b>Effective Date</b>"). BY CLICKING ON THE "I ACCEPT"
                  BUTTON BELOW OR BY ACCESSING OR USING THE DIGITAL SERVICES YOU
                  (A) ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTAND THIS
                  AGREEMENT; (B) REPRESENT AND WARRANT THAT YOU HAVE THE RIGHT,
                  POWER, AND AUTHORITY TO ENTER INTO THIS AGREEMENT AND, IF
                  ENTERING INTO THIS AGREEMENT FOR AN ORGANIZATION, THAT YOU
                  HAVE THE LEGAL AUTHORITY TO BIND THAT ORGANIZATION; (C)
                  REPRESENT AND WARRANT THAT YOU (OR YOUR ORGANIZATION, AS
                  APPLICABLE) HOLD ALL NECESSARY LICENSES AND ARE IN FULL
                  COMPLIANCE WITH ALL OBLIGATIONS ASSOICATIONED WITH SERVICES
                  OFFERED BY PROVIDER AND (D) ACCEPT THIS AGREEMENT AND AGREE
                  THAT YOU ARE LEGALLY BOUND BY ITS TERMS.{" "}
                </span>
              </p>

              <p class="Paragraph" style={{ textAlign: "justify" }}>
                <span lang="EN-CA">
                  IF YOU DO NOT AGREE TO THESE TERMS, PLEASE SELECT THE "I
                  DECLINE" BUTTON BELOW. IF YOU DO NOT ACCEPT THESE TERMS, YOU
                  MAY NOT ACCESS OR USE THE DIGITAL SERVICES.{" "}
                </span>
              </p>

              <p
                class="SFPara-Clause"
                style={{
                  marginLeft: "0in",
                  textAlign: "justify",
                  textIndent: "0in",
                }}
              >
                <a name="a000006">
                  <span lang="EN-CA">
                    1.
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      {/* style={{font:"7.0pt"}} */}
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">Definitions</span>
                  </u>
                  <span lang="EN-CA">. </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a372565">
                  <span lang="EN-CA">
                    (a)
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      {/*  */}
                    </span>
                  </span>
                  <span lang="EN-CA">
                    "<b>Aggregated Statistics</b>" has the meaning set forth in{" "}
                  </span>
                </a>
                <a href="#a151559">
                  <span lang="EN-CA">Section 2(d)</span>
                </a>
                <span lang="EN-CA">.</span>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a480222">
                  <span lang="EN-CA">
                    (b)
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      {/*  */}
                    </span>
                  </span>
                  <span lang="EN-CA">
                    "<b>Authorized User</b>" means Customer and Customer's
                    employees, consultants, contractors, and agents (i) who are
                    authorized by Customer to access and use the Digital
                    Services under the rights granted to Customer pursuant to
                    this Agreement and (ii) for whom access to the Digital
                    Services has been purchased hereunder.
                  </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a794034">
                  <span lang="EN-CA">
                    (c)
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      {/*  */}
                    </span>
                  </span>
                  <span lang="EN-CA">
                    "<b>Digital Services</b>" means the services provided by
                    Provider under this Agreement through its Quotey software
                    platform.
                  </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a786047">
                  <span lang="EN-CA">
                    (d)
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      {/*  */}
                    </span>
                  </span>
                  <span lang="EN-CA">
                    "<b>Customer Data</b>" means, other than Aggregated
                    Statistics, information, data, and other content, in any
                    form or medium, that is submitted, posted, or otherwise
                    transmitted by or on behalf of Customer or any other
                    Authorized User through the Digital Services.
                  </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a355788">
                  <span lang="EN-CA">
                    (e)
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      {/*  */}
                    </span>
                  </span>
                  <span lang="EN-CA">
                    "<b>Provider IP</b>" means all Provider’s intellectual
                    property rights now or hereafter in existence, including any
                    and all patent, copyright, trademark, trade secret rights,
                    the Digital Services and all intellectual property provided
                    to Customer or any other Authorized User in connection with
                    the foregoing. For the avoidance of doubt, Provider IP
                    includes Aggregated Statistics and any information, data, or
                    other content derived from Provider's monitoring of
                    Customer's access to or use of the Digital Services, but
                    does not include Customer Data.
                  </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a422205">
                  <span lang="EN-CA">
                    (f)
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      {/* &nbsp; */}
                    </span>
                  </span>
                  <span lang="EN-CA">
                    "<b>Third-Party Products</b>" means any products, content,
                    services, information, websites, or other materials that are
                    owned by third parties and are incorporated into or
                    accessible through the Digital Services.
                  </span>
                </a>
              </p>

              <p
                class="SFPara-Clause"
                // style={{marginLeft:"0in",textAlign:"justify",textIndent:"0in"}}
                style={{
                  marginLeft: "0in",
                  textAlign: "justify",
                  textIndent: "0in",
                }}
              >
                <a name="a109733">
                  <span lang="EN-CA">
                    2.
                    <span
                      style={{ fontStyle: "7.0pt 'Times New Roman'" }}
                    ></span>
                  </span>
                  <u>
                    <span lang="EN-CA">Access and Use</span>
                  </u>
                  <span lang="EN-CA">.</span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a945844">
                  <span lang="EN-CA">
                    (a)
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      {/*  */}
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">Provision of Access</span>
                  </u>
                  <span lang="EN-CA">
                    . Subject to and conditioned on your payment of Fees and
                    compliance with all other terms and conditions of this
                    Agreement, Provider hereby grants you a revocable,
                    non-exclusive, non-transferable, non-sublicensable, limited
                    right to access and use the Digital Services during the Term
                    solely for your internal business operations by Authorized
                    Users in accordance with the terms and conditions herein.
                    Provider shall provide you the necessary passwords and
                    access credentials to allow you to access the Digital
                    Services.{" "}
                  </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a865933">
                  <span lang="EN-CA">
                    (b)
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      {/*  */}
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">Downloadable Software</span>
                  </u>
                  <span lang="EN-CA">
                    . Use of the Digital Services may require or include use of
                    downloadable software. Provider grants you a
                    non-transferable, non-exclusive, non-assignable, limited
                    right for Authorized Users to use downloadable software we
                    provide as part of the Digital Services. Any Third-Party
                    Products that consist of downloadable software are subject
                    to the terms of{" "}
                  </span>
                </a>
                <a href="#a999489">
                  <span lang="EN-CA">Section 3(e)</span>
                </a>
                <span lang="EN-CA">.</span>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a242470">
                  <span lang="EN-CA">
                    (c)
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      {/*  */}
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">Use Restrictions</span>
                  </u>
                  <span lang="EN-CA">
                    . You shall not, and shall not permit any Authorized Users
                    to, use the Digital Services or any software component of
                    the Digital Services for any purposes beyond the scope of
                    the access granted in this Agreement. You shall not at any
                    time, directly or indirectly, and shall not permit any
                    Authorized Users to: (i) copy, modify, or create derivative
                    works of the Digital Services or any software component of
                    the Digital Services, in whole or in part; (ii) rent, lease,
                    lend, sell, license, sublicense, assign, distribute,
                    publish, transfer, or otherwise make available the Digital
                    Services except as expressly permitted under this Agreement;
                    (iii) reverse engineer, disassemble, decompile, decode,
                    adapt, or otherwise attempt to derive or gain access to any
                    software component of the Digital Services, in whole or in
                    part; (iv) remove any proprietary notices from the Digital
                    Services; or (v) use the Digital Services in any manner or
                    for any purpose that infringes, misappropriates, or
                    otherwise violates any intellectual property right or other
                    right of any person, including any applicable privacy
                    rights, or that violates any applicable law, regulation, or
                    rule.
                  </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a151559">
                  <span lang="EN-CA">
                    (d)
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      {/*  */}
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">Aggregated Statistics</span>
                  </u>
                  <span lang="EN-CA">
                    . Notwithstanding anything to the contrary in this
                    Agreement, Provider may monitor Customer's use of the
                    Digital Services and collect and compile data and
                    information related to Customer's use of the Digital
                    Services to be used by Provider in an aggregated and
                    anonymized manner, including to compile statistical and
                    performance information related to the provision and
                    operation of the Digital Services ("
                    <b>Aggregated Statistics</b>"). As between Provider and you,
                    all right, title, and interest in Aggregated Statistics, and
                    all intellectual property rights therein, belong to and are
                    retained solely by Provider. You acknowledge that Provider
                    may compile Aggregated Statistics based on Customer Data
                    input into the Digital Services. You agree that Provider may
                    (i) make Aggregated Statistics publicly available in
                    compliance with applicable law, and (ii) use Aggregated
                    Statistics to the extent and in the manner permitted under
                    applicable law.{" "}
                  </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a194237">
                  <span lang="EN-CA">
                    (e)
                    <span
                      style={{ fontStyle: "7.0pt 'Times New Roman'" }}
                    ></span>
                  </span>
                  <u>
                    <span lang="EN-CA">Reservation of Rights</span>
                  </u>
                  <span lang="EN-CA">
                    . Provider reserves all rights not expressly granted to
                    Customer in this Agreement. Except for the limited rights
                    and licences expressly granted under this Agreement, nothing
                    in this Agreement grants, by implication, waiver, estoppel,
                    or otherwise, to Customer or any third party any
                    intellectual property rights or other right, title, or
                    interest in or to the Provider IP.
                  </span>
                </a>
                <span lang="EN-CA">
                  All right, title, and interest in and to the Provider IP are
                  and will remain with Provider, and Customer hereby
                  unconditionally and irrevocably grants to Provider an
                  assignment of all right, title, and interest in and to the
                  Provider IP, including the Aggregated Statistics, and
                  unconditionally and irrevocably waives all moral rights
                  therein.
                </span>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a724817">
                  <span lang="EN-CA">
                    (f)
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      {/* &nbsp; */}
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">Suspension</span>
                  </u>
                  <span lang="EN-CA">
                    . Notwithstanding anything to the contrary in this
                    Agreement, Provider may temporarily suspend Customer's and
                    any other Authorized User's access to any portion or all of
                    the Digital Services if: (i) Provider reasonably determines
                    that (A) there is a threat or attack on any of the Provider
                    IP; (B) Customer's or any other Authorized User's use of the
                    Provider IP disrupts or poses a security risk to the
                    Provider IP or to any other customer or vendor of Provider;
                    (C) Customer or any other Authorized User is using the
                    Provider IP for fraudulent or illegal activities; (D)
                    subject to applicable law, Customer has ceased to continue
                    its business in the ordinary course, made an assignment for
                    the benefit of creditors or similar disposition of its
                    assets, or become the subject of any bankruptcy,
                    reorganization, liquidation, dissolution, or similar
                    proceeding; or (E) Provider's provision of the Digital
                    Services to Customer or any other Authorized User is
                    prohibited by applicable law; (ii) any vendor of Provider
                    has suspended or terminated Provider's access to or use of
                    any third-party services or products required to enable
                    Customer to access the Digital Services; or (iii) in
                    accordance with{" "}
                  </span>
                </a>
                <span lang="EN-CA">Section </span>
                <span lang="EN-CA">5</span>
                <span lang="EN-CA">
                  {" "}
                  (any such suspension described in subclause (i), (ii), or
                  (iii), a "<b>Service Suspension</b>"). Provider shall use
                  commercially reasonable efforts to provide written notice of
                  any Service Suspension to Customer and to provide updates
                  regarding resumption of access to the Digital Services
                  following any Service Suspension. Provider shall use
                  commercially reasonable efforts to resume providing access to
                  the Digital Services as soon as reasonably possible after the
                  event giving rise to the Digital Services Suspension is cured.
                  Provider will have no liability for any damage, liabilities,
                  losses (including any loss of data or profits), or any other
                  consequences that Customer or any other Authorized User may
                  incur as a result of a Service Suspension.
                </span>
              </p>

              <p
                class="SFPara-Clause"
                style={{
                  marginLeft: "0in",
                  textAlign: "justify",
                  textIndent: "0in",
                }}
              >
                <a name="a235305">
                  <span lang="EN-CA">
                    3.
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      &nbsp;
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">Customer Responsibilities</span>
                  </u>
                  <span lang="EN-CA">.</span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a685706">
                  <span lang="EN-CA">
                    (a)
                    <span
                      style={{ fontStyle: "7.0pt 'Times New Roman'" }}
                    ></span>
                  </span>
                  <u>
                    <span lang="EN-CA">Acceptable Use Policy</span>
                  </u>
                  <span lang="EN-CA">
                    . The Digital Services may not be used for unlawful,
                    fraudulent, offensive, or obscene activity. You will comply
                    with all terms and conditions of this Agreement, all
                    applicable laws, rules, and regulations, and all guidelines,
                    standards, and requirements that may be provided to you by
                    Provider from time to time.
                  </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a819239">
                  <span lang="EN-CA">
                    (b)
                    <span
                      style={{ fontStyle: "7.0pt 'Times New Roman'" }}
                    ></span>
                  </span>
                  <u>
                    <span lang="EN-CA">Account Use</span>
                  </u>
                  <span lang="EN-CA">
                    . You are responsible and liable for all uses of the Digital
                    Services resulting from access provided by you, directly or
                    indirectly, whether such access or use is permitted by or in
                    violation of this Agreement. Without limiting the generality
                    of the foregoing, you are responsible for all acts and
                    omissions of Authorized Users, and any act or omission by an
                    Authorized User that would constitute a breach of this
                    Agreement if taken by you will be deemed a breach of this
                    Agreement by you. You shall use reasonable efforts to make
                    all Authorized Users aware of this Agreement's provisions as
                    applicable to such Authorized User's use of the Digital
                    Services, and shall cause Authorized Users to comply with
                    such provisions.{" "}
                  </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a357918">
                  <span lang="EN-CA">
                    (c)
                    <span
                      style={{ fontStyle: "7.0pt 'Times New Roman'" }}
                    ></span>
                  </span>
                  <u>
                    <span lang="EN-CA">Customer Data</span>
                  </u>
                  <span lang="EN-CA">
                    . You hereby grant to Provider a non-exclusive,
                    royalty-free, worldwide licence to reproduce, distribute,
                    and otherwise use and display the Customer Data and perform
                    all acts with respect to the Customer Data as may be
                    necessary for Provider to provide the Digital Services to
                    you, and a non-exclusive, perpetual, irrevocable,
                    royalty-free, worldwide licence to reproduce, distribute,
                    modify, and otherwise use and display Customer Data
                    incorporated within the Aggregated Statistics. You will
                    ensure that Customer Data and any Authorized User's use of
                    Customer Data will not violate any policy or terms
                    referenced in or incorporated into this Agreement or any
                    applicable law. You are solely responsible for the
                    development, content, operation, maintenance, and use of
                    Customer Data.
                  </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a120546">
                  <span lang="EN-CA">
                    (d)
                    <span
                      style={{ fontStyle: "7.0pt 'Times New Roman'" }}
                    ></span>
                  </span>
                  <u>
                    <span lang="EN-CA">Passwords and Access Credentials</span>
                  </u>
                  <span lang="EN-CA">
                    . You are responsible for keeping your passwords and access
                    credentials associated with the Digital Services
                    confidential. You will not sell or transfer them to any
                    other person or entity. You will promptly notify us about
                    any unauthorized access to your passwords or access
                    credentials.
                  </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a999489">
                  <span lang="EN-CA">
                    (e)
                    <span
                      style={{ fontStyle: "7.0pt 'Times New Roman'" }}
                    ></span>
                  </span>
                  <u>
                    <span lang="EN-CA">Third-Party Products</span>
                  </u>
                  <span lang="EN-CA">
                    . The Services may permit access to Third-Party Products.
                    For purposes of this Agreement, such Third-Party Products
                    are subject to their own terms and conditions presented to
                    you for acceptance within the Digital Services by website
                    link or otherwise. If you do not agree to abide by the
                    applicable terms for any such Third-Party Products, then you
                    should not install, access, or use such Third-Party
                    Products.
                  </span>
                </a>
              </p>

              <p
                class="SFPara-Clause"
                style={{
                  marginLeft: "0in",
                  textAlign: "justify",
                  textIndent: "0in",
                }}
              >
                <a name="a165355">
                  <span lang="EN-CA">
                    4.
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      &nbsp;
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">Fees and Payment</span>
                  </u>
                  <span lang="EN-CA">
                    . Customer shall pay Provider monthly fees ("<b>Fees</b>")
                    on terms determined by Provider, in its sole discretion.
                    Customer shall make all payments hereunder in Canadian
                    dollars on or before the due date. If Customer fails to make
                    any payment when due, Provider may suspend, in accordance
                    with{" "}
                  </span>
                </a>
                <a href="#a724817">
                  <span lang="EN-CA">Section 2(f)</span>
                </a>
                <span lang="EN-CA">
                  , Customer's and all other Authorized Users' access to any
                  portion or all of the Digital Services until such amounts are
                  paid in full.{" "}
                </span>
              </p>

              <p
                class="SFPara-Clause"
                style={{
                  marginLeft: "0in",
                  textAlign: "justify",
                  textIndent: "0in",
                }}
              >
                <a name="a767985">
                  <span lang="EN-CA">
                    5.
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      &nbsp;
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">Taxes</span>
                  </u>
                  <span lang="EN-CA">
                    . All Fees and other amounts payable by Customer under this
                    Agreement are exclusive of taxes and similar assessments.
                    Customer is responsible for all harmonized sales tax (HST),
                    provincial sales tax (PST), goods and services tax (GST),
                    value added tax, use and excise taxes, and any other similar
                    taxes, duties, and charges of any kind imposed by any
                    federal, provincial, territorial, or local governmental
                    entity on any amounts payable by Customer hereunder, other
                    than any taxes imposed on Provider's income.
                  </span>
                </a>
              </p>

              <p
                class="SFPara-Clause"
                style={{
                  marginLeft: "0in",
                  textAlign: "justify",
                  textIndent: "0in",
                }}
              >
                <a name="a328793">
                  <span lang="EN-CA">
                    6.
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      &nbsp;
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">Confidential Information</span>
                  </u>
                  <span lang="EN-CA">
                    . From time to time during the Term, Provider, and Customer
                    may disclose or make available to the other party
                    information about its business affairs, products,
                    confidential intellectual property, trade secrets,
                    third-party confidential information, and other sensitive or
                    proprietary information, whether orally or in written,
                    electronic, or other form or media/in written or electronic
                    form or media, and whether or not marked, designated, or
                    otherwise identified as "confidential" at the time of
                    disclosure (collectively, "<b>Confidential Information</b>
                    "). Confidential Information does not include information
                    that, at the time of disclosure is: (a) in the public
                    domain; (b) known to the receiving party; (c) rightfully
                    obtained by the receiving party on a non-confidential basis
                    from a third party; or (d) independently developed by the
                    receiving party. The Customer (as the “
                    <b>receiving party</b>”) shall not disclose Provider’s (as
                    the “<b>disclosing party</b>”) Confidential Information to
                    any person or entity, except to the receiving party's
                    employees, agents, or subcontractors who have a need to know
                    the Confidential Information for the receiving party to
                    exercise its rights or perform its obligations hereunder and
                    who are required to protect the Confidential Information in
                    a manner no less stringent than required under this
                    Agreement. Notwithstanding the foregoing, each party may
                    disclose Confidential Information to the limited extent
                    required (i) to comply with the order of a court or other
                    governmental body, or as otherwise necessary to comply with
                    applicable law, provided that the party making the
                    disclosure pursuant to the order shall first have given
                    written notice to the other party and made a reasonable
                    effort to obtain a protective order; or (ii) to establish a
                    party's rights under this Agreement, including to make
                    required court filings. Each party's obligations of
                    non-disclosure with regard to Confidential Information are
                    effective as of the date such Confidential Information is
                    first disclosed to the receiving party and will not expire
                    unless expiration is mutually agreed in writing.{" "}
                  </span>
                </a>
              </p>

              <p
                class="SFPara-Clause"
                style={{
                  marginLeft: "0in",
                  textAlign: "justify",
                  textIndent: "0in",
                }}
              >
                <a name="a000038">
                  <span lang="EN-CA">
                    7.
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      &nbsp;
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">Privacy Policy</span>
                  </u>
                  <span lang="EN-CA">
                    . Provider complies with its privacy policy ("
                    <b>Privacy Policy</b>") when providing the Digital Services.
                    The Privacy Policy is subject to change as described
                    therein. By accessing, using, and providing information to
                    or through the Digital Services, you acknowledge that you
                    have reviewed and accepted our Privacy Policy, and you
                    consent to all actions taken by us with respect to your
                    information in compliance with the then-current version of
                    our Privacy Policy.
                  </span>
                </a>
              </p>

              <p
                class="SFPara-Clause"
                style={{
                  marginLeft: "0in",
                  textAlign: "justify",
                  textIndent: "0in",
                }}
              >
                <a name="a904128">
                  <span lang="EN-CA">
                    8.
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      &nbsp;
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">
                      Intellectual Property Ownership; Feedback
                    </span>
                  </u>
                  <span lang="EN-CA">
                    . As between you and us, (a) we own all right, title, and
                    interest, including all intellectual property rights, in and
                    to the Digital Services and (b) you own all right, title,
                    and interest, including all intellectual property rights, in
                    and to Customer Data. If you or any of your employees,
                    contractors, or agents sends or transmits any communications
                    or materials to us by mail, email, telephone, or otherwise,
                    suggesting or recommending changes to the Digital Services,
                    including, without limitation, new features or functionality
                    relating thereto, or any comments, questions, suggestions,
                    or the like ("<b>Feedback</b>"), we are free to use such
                    Feedback irrespective of any other obligation or limitation
                    between you and us governing such Feedback. All such
                    Feedback is and will be treated as non-confidential. You
                    hereby assign to us on your behalf, and shall cause your
                    employees, contractors, and agents to assign, all right,
                    title, and interest in, and we are free to use, without any
                    attribution or compensation to you or any third party, any
                    ideas, know-how, concepts, techniques, or other intellectual
                    property rights contained in the Feedback, for any purpose
                    whatsoever, although we are not required to use any
                    Feedback.
                  </span>
                </a>
              </p>

              <p
                class="SFPara-Clause"
                style={{
                  marginLeft: "0in",
                  textAlign: "justify",
                  textIndent: "0in",
                }}
              >
                <a name="a000078">
                  <span lang="EN-CA">
                    9.
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      &nbsp;
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">
                      Limited Warranty and Warranty Disclaimer
                    </span>
                  </u>
                  <span lang="EN-CA">.</span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a795724">
                  <span lang="EN-CA">
                    (a)
                    <span
                      style={{ fontStyle: "7.0pt 'Times New Roman'" }}
                    ></span>
                  </span>
                  <u>
                    <span lang="EN-CA">Customer Warranty</span>
                  </u>
                  <span lang="EN-CA">
                    . You warrant that you own all right, title, and interest,
                    including all intellectual property rights, in and to
                    Customer Data and that both the Customer Data and your use
                    of the Digital Services comply with all applicable laws.
                  </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a810303">
                  <span lang="EN-CA">
                    (b)
                    <span
                      style={{ fontStyle: "7.0pt 'Times New Roman'" }}
                    ></span>
                  </span>
                  <span lang="EN-CA">
                    THE DIGITAL SERVICES ARE PROVIDED "AS IS" AND PROVIDER
                    SPECIFICALLY DISCLAIMS ALL WARRANTIES AND CONDITIONS,
                    WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE. PROVIDER
                    SPECIFICALLY DISCLAIMS ALL IMPLIED WARRANTIES AND CONDITIONS
                    OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE,
                    AND NON-INFRINGEMENT, AND ALL WARRANTIES ARISING FROM COURSE
                    OF DEALING, USAGE, OR TRADE PRACTICE.{" "}
                  </span>
                </a>
              </p>

              <p
                class="SFPara-Clause"
                style={{
                  marginLeft: "0in",
                  textAlign: "justify",
                  textIndent: "0in",
                }}
              >
                <a name="a000090">
                  <span lang="EN-CA">
                    10.
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      &nbsp;
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">Indemnification</span>
                  </u>
                  <span lang="EN-CA">. </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a129415">
                  <span lang="EN-CA">
                    (a)
                    <span
                      style={{ fontStyle: "7.0pt 'Times New Roman'" }}
                    ></span>
                  </span>
                  <u>
                    <span lang="EN-CA">Provider Indemnification</span>
                  </u>
                  <span lang="EN-CA">
                    . Customer shall indemnify, hold harmless, and, at
                    Provider's option, defend Provider and its officers,
                    directors, employees, agents, affiliates, successors, and
                    assigns from and against any and all losses, damages,
                    liabilities, deficiencies, claims, actions, judgments,
                    settlements, interest, awards, penalties, fines, costs, or
                    expenses of whatever kind, including legal fees ("
                    <b>Losses</b>"), incurred by Customer resulting from any
                    third-party claim, suit, action, or proceeding ("
                    <b>Third-Party Claim</b>") (i) that the Customer Data, or
                    any use of the Customer Data in accordance with this
                    Agreement, infringes or misappropriates such third party's
                    intellectual property rights; (ii) resulting from Customer’s
                    error and omissions; or (iii) based on Customer's or any
                    Authorized User's negligence or wilful misconduct or use of
                    the Digital Services in a manner not authorized by this
                    Agreement; provided that Customer may not settle any
                    Third-Party Claim against Provider unless Provider consents
                    to such settlement, and further <i>provided that</i>
                    Provider will have the right, at its option, to defend
                    itself against any such Third-Party Claim or to participate
                    in the defence thereof by counsel of its own choice.
                  </span>
                </a>
              </p>

              <p
                class="SFPara-Clause"
                style={{
                  marginLeft: "0in",
                  textAlign: "justify",
                  textIndent: "0in",
                }}
              >
                <a name="a000086">
                  <span lang="EN-CA">
                    11.
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      &nbsp;
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">LIMITATIONS OF LIABILITY</span>
                  </u>
                  <span lang="EN-CA">
                    . IN NO EVENT WILL PROVIDER BE LIABLE UNDER OR IN CONNECTION
                    WITH THIS AGREEMENT UNDER ANY LEGAL OR EQUITABLE THEORY,
                    INCLUDING BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE),
                    STRICT LIABILITY, OR OTHERWISE, FOR ANY: (a) CONSEQUENTIAL,
                    INCIDENTAL, INDIRECT, EXEMPLARY, SPECIAL, AGGRAVATED, OR
                    PUNITIVE DAMAGES; (b) INCREASED COSTS, DIMINUTION IN VALUE
                    OR LOST BUSINESS, PRODUCTION, REVENUES, OR PROFITS; (c) LOSS
                    OF GOODWILL OR REPUTATION; (d) USE, INABILITY TO USE, LOSS,
                    INTERRUPTION, DELAY, OR RECOVERY OF ANY DATA, OR BREACH OF
                    DATA OR SYSTEM SECURITY; OR (e) COST OF REPLACEMENT GOODS OR
                    SERVICES, IN EACH CASE REGARDLESS OF WHETHER PROVIDER WAS
                    ADVISED OF THE POSSIBILITY OF SUCH LOSSES OR DAMAGES OR SUCH
                    LOSSES OR DAMAGES WERE OTHERWISE FORESEEABLE. IN NO EVENT
                    WILL PROVIDER'S AGGREGATE LIABILITY ARISING OUT OF OR
                    RELATED TO THIS AGREEMENT UNDER ANY LEGAL OR EQUITABLE
                    THEORY, INCLUDING BREACH OF CONTRACT, TORT (INCLUDING
                    NEGLIGENCE), STRICT LIABILITY, OR OTHERWISE EXCEED THE TOTAL
                    AMOUNTS PAID TO PROVIDER UNDER THIS AGREEMENT IN THE TWELVE
                    (12) MONTH PERIOD PRECEDING THE EVENT GIVING RISE TO THE
                    CLAIM.&nbsp;{" "}
                  </span>
                </a>
              </p>

              <p
                class="SFPara-Clause"
                style={{
                  marginLeft: "0in",
                  textAlign: "justify",
                  textIndent: "0in",
                }}
              >
                <a name="a000058">
                  <span lang="EN-CA">
                    12.
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      &nbsp;
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">Term and Termination</span>
                  </u>
                  <span lang="EN-CA">. </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a411115">
                  <span lang="EN-CA">
                    (a)
                    <span
                      style={{ fontStyle: "7.0pt 'Times New Roman'" }}
                    ></span>
                  </span>
                  <u>
                    <span lang="EN-CA">Term</span>
                  </u>
                  <span lang="EN-CA">
                    . The term of this Agreement begins on the date Provider
                    notifies Customer it can access the Digital Services and
                    continues until terminated.{" "}
                  </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a765814">
                  <span lang="EN-CA">
                    (b)
                    <span
                      style={{ fontStyle: "7.0pt 'Times New Roman'" }}
                    ></span>
                  </span>
                  <u>
                    <span lang="EN-CA">Termination</span>
                  </u>
                  <span lang="EN-CA">
                    . In addition to any other express termination right set
                    forth in this Agreement:
                  </span>
                </a>
              </p>

              <p class="SFParasubclause2" style={{ textAlign: "justify" }}>
                <a name="a142398">
                  <span lang="EN-CA">
                    (i)
                    <span
                      style={{ fontStyle: "7.0pt 'Times New Roman'" }}
                    ></span>
                  </span>
                  <span lang="EN-CA">
                    Provider may terminate this Agreement, for any reason upon
                    thirty (30) days' advance notice
                  </span>
                </a>
                <span lang="EN-CA">;</span>
              </p>

              <p class="SFParasubclause2" style={{ textAlign: "justify" }}>
                <a name="a230260">
                  <span lang="EN-CA">
                    (ii)
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      {/* &nbsp; */}
                    </span>
                  </span>
                  <span lang="EN-CA">
                    either party may terminate this Agreement, effective on
                    written notice to the other party, if the other party
                    materially breaches this Agreement, and such breach: (A) is
                    incapable of cure; or (B) being capable of cure, remains
                    uncured thirty (30) days after the non-breaching party
                    provides the breaching party with written notice of such
                    breach; or
                  </span>
                </a>
              </p>

              <p class="SFParasubclause2" style={{ textAlign: "justify" }}>
                <a name="a878462">
                  <span lang="EN-CA">
                    (iii)
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      {/* &nbsp; */}
                    </span>
                  </span>
                  <span lang="EN-CA">
                    either party may terminate this Agreement, effective
                    immediately upon written notice to the other party, if the
                    other party: (A) becomes insolvent or is generally unable to
                    pay, or fails to pay, its debts as they become due; (B)
                    files or has filed against it, a petition for voluntary or
                    involuntary bankruptcy or otherwise becomes subject,
                    voluntarily or involuntarily, to any proceeding under any
                    domestic or foreign bankruptcy or insolvency law; (C) makes
                    or seeks to make a general assignment for the benefit of its
                    creditors; or (D) applies for or has appointed a receiver,
                    trustee, custodian, or similar agent appointed by order of
                    any court of competent jurisdiction to take charge of or
                    sell any material portion of its property or business.
                  </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a711472">
                  <span lang="EN-CA">
                    (c)
                    <span
                      style={{ fontStyle: "7.0pt 'Times New Roman'" }}
                    ></span>
                  </span>
                  <u>
                    <span lang="EN-CA">
                      Effect of Expiration or Termination
                    </span>
                  </u>
                  <span lang="EN-CA">
                    . Upon expiration or earlier termination of this Agreement,
                    Customer shall immediately discontinue use of the Provider
                    IP. No termination of this Agreement will affect Customer's
                    obligation to pay all Fees that may have become due before
                    such expiration or termination, or entitle Customer to any
                    refund.{" "}
                  </span>
                </a>
              </p>

              <p
                class="SFParasubclause1"
                style={{ textAlign: "justify", textIndent: "0in" }}
              >
                <a name="a920388">
                  <span lang="EN-CA">
                    (d)
                    <span
                      style={{ fontStyle: "7.0pt 'Times New Roman'" }}
                    ></span>
                  </span>
                  <u>
                    <span lang="EN-CA">Survival</span>
                  </u>
                  <span lang="EN-CA">. This Section 13(d), </span>
                </a>
                <span lang="EN-CA">Section </span>
                <span lang="EN-CA">5</span>
                <span lang="EN-CA">,</span>
                <span lang="EN-CA">Section </span>
                <span lang="EN-CA">11</span>
                <span lang="EN-CA">, </span>
                <span lang="EN-CA">Section </span>
                <span lang="EN-CA">12</span>
                <span lang="EN-CA">
                  , and any right, obligation, or required performance of the
                  parties in this Agreement which, by its express terms or
                  nature and context is intended to survive termination or
                  expiration of this Agreement, will survive any such
                  termination or expiration.
                </span>
              </p>

              <p
                class="SFPara-Clause"
                style={{
                  marginLeft: "0in",
                  textAlign: "justify",
                  textIndent: "0in",
                }}
              >
                <a name="a649503">
                  <span lang="EN-CA">
                    13.
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      &nbsp;
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">Modifications.</span>
                  </u>
                </a>
                <span lang="EN-CA"> </span>
                <span lang="EN-CA">
                  You acknowledge and agree that we have the right, in our sole
                  discretion, to modify this Agreement from time to time, and
                  that modified terms become effective on posting. You will be
                  notified of modifications through direct email communication
                  from us. You are responsible for reviewing and becoming
                  familiar with any such modifications. Your continued use of
                  the Digital Services after the effective date of the
                  modifications will be deemed acceptance of the modified terms.{" "}
                </span>
              </p>

              <p
                class="SFPara-Clause"
                style={{
                  marginLeft: "0in",
                  textAlign: "justify",
                  textIndent: "0in",
                }}
              >
                <a name="a000110">
                  <span lang="EN-CA">
                    14.
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      &nbsp;
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">Governing Law</span>
                  </u>
                  <span lang="EN-CA">
                    . This Agreement and all related documents including all
                    exhibits attached hereto, and all matters arising out of or
                    relating to this Agreement, whether sounding in contract,
                    tort, or statute, are governed by, and construed in
                    accordance with, the laws of the Province of Ontario and the
                    federal laws of Canada applicable therein, without giving
                    effect to any choice or conflict of law provision or rule
                    (whether of the Province of Ontario or any other
                    jurisdiction) that would cause the application of the laws
                    of any jurisdiction other than those of the Province of
                    Ontario.{" "}
                  </span>
                </a>
              </p>

              <p
                class="SFPara-Clause"
                style={{
                  marginLeft: "0in",
                  textAlign: "justify",
                  textIndent: "0in",
                }}
              >
                <a name="a000144">
                  <span lang="EN-CA">
                    15.
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      &nbsp;
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">Choice of Forum</span>
                  </u>
                  <span lang="EN-CA">
                    . Any legal suit, action, litigation, or proceeding of any
                    kind whatsoever in any way arising out of, from, or relating
                    to this Agreement, including all statements of work,
                    exhibits, schedules, attachments, and appendices attached to
                    this Agreement, the services provided hereunder, and all
                    contemplated transactions, shall be instituted in the courts
                    of the Province of Ontario, and each party irrevocably
                    submits to the exclusive jurisdiction of such courts in any
                    such suit, action, litigation, or proceeding.
                  </span>
                </a>
              </p>

              <p
                class="SFPara-Clause"
                style={{
                  marginLeft: "0in",
                  textAlign: "justify",
                  textIndent: "0in",
                }}
              >
                <a name="a863792">
                  <span lang="EN-CA">
                    16.
                    <span style={{ fontStyle: "7.0pt 'Times New Roman'" }}>
                      &nbsp;
                    </span>
                  </span>
                  <u>
                    <span lang="EN-CA">Miscellaneous</span>
                  </u>
                  <span lang="EN-CA">
                    . This Agreement constitutes the entire agreement and
                    understanding between the parties hereto with respect to the
                    subject matter hereof and supersedes all prior and
                    contemporaneous understandings, agreements, representations,
                    and warranties, both written and oral, with respect to such
                    subject matter. Any notices to us must be sent to our
                    corporate headquarters and must be delivered either in
                    person, by certified or registered mail, return receipt
                    requested and postage prepaid, or by recognized overnight
                    courier service, and are deemed given upon receipt by us.
                    Notwithstanding the foregoing, you hereby consent to
                    receiving electronic communications from us. These
                    electronic communications may include notices about
                    applicable fees and charges, transactional information, and
                    other information concerning or related to the Digital
                    Services. You agree that any notices, agreements,
                    disclosures, or other communications that we send to you
                    electronically will satisfy any legal communication
                    requirements, including that such communications be in
                    writing. The invalidity, illegality, or unenforceability of
                    any provision herein does not affect any other provision
                    herein or the validity, legality, or enforceability of such
                    provision in any other jurisdiction. Any failure to act by
                    us with respect to a breach of this Agreement by you or
                    others does not constitute a waiver and will not limit our
                    rights with respect to such breach or any subsequent
                    breaches. This Agreement is personal to you and may not be
                    assigned or transferred for any reason whatsoever without
                    our prior written consent and any action or conduct in
                    violation of the foregoing will be void and without effect.
                    We expressly reserve the right to assign this Agreement and
                    to delegate any of its obligations hereunder.
                  </span>
                </a>
              </p>

              <p class="SFPara-Clause" style={{ textAlign: "justify" }}>
                <span lang="EN-CA">&nbsp;</span>
              </p>
            </div>
            <div className="form-group row">
              <div className="col-sm-9 mb-1">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="defaultCheck1"
                    onChange={(event) => {
                      setScrollCheck(event.target.checked);
                    }}
                    defaultChecked={false}
                  />
                  <label className="form-check-label " for="defaultCheck1">
                    <b>Accept Terms and Condition</b>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </PerfectScrollbar>
      </div>
      <br />
      <ActionButtons {...props} nextStep={validate3} />
    </div>
  );
};
const Four = (props) => {
  const languageSelected = props.languageSelected;
  const [token, setToken] = useState();
  const [tokenError, setTokenError] = useState("");
  const dispatch = useDispatch();
  const provinces = useSelector(getProvinceInformation);

  const [data, setData] = useState({});
  const [selectProvince, setSelectProvince] = useState([]);
  const [selectName, setSelectName] = useState("");

  const translations = {
    en: {
      paymentConfirmation: "Payment Confirmation",
      paymentDetails:
        "Your credit card will be charged today for $100 + tax. This provides a license for you to add up to 10 users at your brokerage. Additional users can be added at the cost of $10 per additional user each month (which will accrue into future payment periods). Your credit card will be automatically charged every 30 days for continued use of Quotey where the amount charged will be $100 for up to 10 users plus $10 per additional user. Your brokerage’s user count will be calculated based on the number of active users in the previous 30 day period. All charges are subject to HST / GST or equivalent provincial sales tax.",
    },
    fr: {
      paymentConfirmation: "Confirmation de Paiement",
      paymentDetails:
        "Votre carte de crédit sera débitée aujourd'hui de 100 $ + taxes. Cela fournit une licence vous permettant d'ajouter jusqu'à 10 utilisateurs à votre cabinet. Des utilisateurs supplémentaires peuvent être ajoutés au coût de 10 $ par utilisateur supplémentaire chaque mois (qui s'accumuleront dans les périodes de paiement futures). Votre carte de crédit sera automatiquement débitée tous les 30 jours pour l'utilisation continue de Quotey où le montant facturé sera de 100 $ pour jusqu'à 10 utilisateurs plus 10 $ par utilisateur supplémentaire. Le nombre d'utilisateurs de votre cabinet sera calculé en fonction du nombre d'utilisateurs actifs lors de la période de 30 jours précédente. Tous les frais sont soumis à la TVH / TPS ou à une taxe de vente provinciale équivalente.",
    },
  };

  useEffect(() => {
    if (provinces) {
      setSelectProvince(provinces.provinces);
    }
  }, [provinces]);
  const handleCardData = (val) => {
    setToken(val);
  };
  const validateData = () => {
    if (provinces) {
      setSelectProvince(provinces.provinces);
      selectProvince?.map((prv) => {
        if (props && prv.code === props.user?.province) {
          setSelectName(prv && prv.name);
        }
      });
    }
    if (!token) {
      // toast.success("Please Add Card Details");
      setTokenError("Please Add Card Details");
    } else if (token && token.error) {
      setTokenError(token.error.message);
    } else if (token && token.token) {
      props.nextStep();
      props.userCallback(token);
    }
  };
  return (
    <div className="container-fluid px-5 text-secondary">
      <h6
        style={{
          paddingTop: "2%",
        }}
      >
        <b>{translations[languageSelected].paymentConfirmation}</b>
      </h6>
      <p
        style={{
          fontSize: "1.1rem",
          display: "flex",
        }}
      >
        {translations[languageSelected].paymentDetails}
      </p>
      <Payment
        data={props.user}
        languageSelected={languageSelected}
        handleCardData={handleCardData}
      />
      <br />
      <ActionButtons {...props} nextStep={validateData} />
    </div>
  );
};
const Five = (props) => {
  const languageSelected = props.languageSelected;
  const dispatch = useDispatch();
  const provinces = useSelector(getProvinceInformation);

  const [data, setData] = useState({});
  const [selectProvince, setSelectProvince] = useState([]);
  const [selectName, setSelectName] = useState("");
  useEffect(() => {
    setSelectProvince(provinces.provinces);
    selectProvince?.map((prv) => {
      if (props && prv.code === props.user?.province) {
        setSelectName(prv && prv.name);
      }
    });
  }, [props]);
  console.log("step4 receive user object");
  const handleLastStep = (val) => {
    props.nextStep();
    props.userCallback(val);
    props.completeCallback();
  };
  const handleCardData = (val) => {
    props.userCallback(val);
  };
  const validate4 = () => {
    props.nextStep();
  };
  useEffect(() => {
    selectProvince?.map((prv) => {
      if (props && prv.code === props.user?.province) {
        setSelectName(prv && prv.name);
      }
    });
  }, []);
  return (
    <div className="container">
      <div className="px-3 ">
        <div className=" py-3" style={{ borderRadius: "10px" }}>
          <h6 className=" fw-normal mb-3 border-bottom ">
            <div className="mb-3">
              {" "}
              <b>
                <span
                  style={{
                    fontFamily: "GibsonSemiBd",
                    fontSize: "1.5vw",
                    display: "flex",
                    marginLeft: "1rem",
                  }}
                >
                  Brokerage Details
                </span>
              </b>
            </div>
          </h6>
          <div className="float-right container-fluid py-3 px-3">
            <div className="row ">
              {props && props.user?.name ? (
                <div className="col-md-6 col-lg-6 col-sm-12 mb-2">
                  <span className="text-secondary float-left">Name</span>
                  <span className="float-right text-dark">
                    {props && props.user?.name}
                  </span>
                  <br />
                </div>
              ) : null}
              {props && props.user?.province ? (
                <div className="col-md-6 col-lg-6 col-sm-12 mb-2">
                  <span className="text-secondary">Province</span>
                  <span className="float-right text-dark">
                    {selectName ? selectName : null}
                  </span>
                  <br />
                </div>
              ) : null}
              {props && props.user?.postalCode ? (
                <div className="col-md-6 col-lg-6 col-sm-12 mb-2">
                  <span className="text-secondary"> PostalCode </span>
                  <span className="float-right text-dark">
                    {props && props.user?.postalCode}
                  </span>
                  <br />
                </div>
              ) : null}
              {props && props.user?.website ? (
                <div className="col-md-6 col-lg-6 col-sm-12 mb-2">
                  <span className="text-secondary"> Website </span>
                  <span className="float-right text-dark">
                    {props && props.user?.website}
                  </span>

                  <br />
                </div>
              ) : null}
              {props && props.user?.addr1 ? (
                <div className="col-md-6  col-lg-6 col-sm-12 mb-2">
                  <span className="text-secondary"> Address </span>
                  <span className="float-right text-dark">
                    {props && props.user?.addr1}
                  </span>

                  <br />
                </div>
              ) : null}
              {props && props.user?.phone ? (
                <div className="col-md-6 col-lg-6 col-sm-12 mb-2">
                  <span className="text-secondary"> Phone Number </span>
                  <span className="float-right text-dark">
                    {props && props.user?.phone}
                  </span>
                  <br />
                </div>
              ) : null}

              {props && props.user?.city ? (
                <div className="col-md-6 col-lg-6 col-sm-12 mb-2">
                  <span className="text-secondary"> city </span>{" "}
                  <span className="float-right text-dark">
                    {props && props.user?.city}
                  </span>
                  <br />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div className="px-3 ">
        <div className=" py-3" style={{ borderRadius: "10px" }}>
          <h6 className=" fw-normal mb-3 border-bottom ">
            <div className="mb-3">
              <b>
                <span
                  style={{
                    fontFamily: "GibsonSemiBd",
                    fontSize: "1.5vw",
                    display: "flex",
                    marginLeft: "1rem",
                  }}
                >
                  User Details
                </span>
              </b>
            </div>
          </h6>
          <div className="float-right container-fluid py-3 px-3">
            <div className="row ">
              {props && props.user?.userName ? (
                <div className="col-md-6 col-lg-6 col-sm-12 col-lg-6 col-sm-12 mb-2">
                  <span className="text-secondary float-left">Name</span>
                  <span className="float-right text-dark">
                    {props && props.user?.userName}
                  </span>
                  <br />
                </div>
              ) : null}
              {props && props.user?.userLocation ? (
                <div className="col-md-6 col-lg-6 col-sm-12 mb-2">
                  <span className="text-secondary"> Location</span>
                  <span className="float-right text-dark">
                    {props && props.user?.userLocation}
                  </span>
                  <br />
                </div>
              ) : null}
              {props && props.user?.userEmail ? (
                <div className="col-md-6 col-lg-6 col-sm-12 mb-2">
                  <span className="text-secondary"> Email</span>
                  <span className="float-right text-dark">
                    {props && props.user?.userEmail}
                  </span>
                  <br />
                </div>
              ) : null}
              {props && props.user.token?.userPassword ? (
                <div className="col-md-6 col-lg-6 col-sm-12 mb-2">
                  <span className="text-secondary"> Password </span>
                  <span className="float-right text-dark">
                    {props && props.user.token?.userPassword}
                  </span>

                  <br />
                </div>
              ) : null}
              {props && props.user?.userRole ? (
                <div className="col-md-6 col-lg-6 col-sm-12 mb-2">
                  <span className="text-secondary"> Role </span>{" "}
                  <span className="float-right text-dark">
                    {props && props.user?.userRole}
                  </span>
                  <br />
                </div>
              ) : null}
              {props && props.user?.userPhoneNumber ? (
                <div className="col-md-6 col-lg-6 col-sm-12 mb-2">
                  <span className="text-secondary"> Phone Number </span>{" "}
                  <span className="float-right text-dark">
                    {props && props.user?.userPhoneNumber}
                  </span>
                  <br />
                </div>
              ) : null}
              {props && props.user?.userBio ? (
                <div className="col-md-6 col-lg-6 col-sm-12 mb-2">
                  <span className="text-secondary"> Biography </span>{" "}
                  <span className="float-right text-dark">
                    {props && props.user?.userBio}
                  </span>
                  <br />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {/* /// */}
      <div className="px-3 ">
        <div className=" py-3" style={{ borderRadius: "10px" }}>
          <h6 className=" fw-normal mb-3 border-bottom ">
            <div className="mb-3">
              {" "}
              <b>
                <span
                  style={{
                    fontFamily: "GibsonSemiBd",
                    fontSize: "1.5vw",
                    display: "flex",
                    marginLeft: "1rem",
                  }}
                >
                  Payment Details
                </span>
              </b>
            </div>
          </h6>
          <div className="float-right container-fluid py-3 px-3">
            <div className="row ">
              <div className="col-6 mb-2">
                <span className="text-secondary float-left">Card</span>
                <span className="float-right text-dark">
                  {props && props.user.token?.card?.brand} (
                  {props && props.user.token?.card?.funding}&nbsp;
                  {props && props.user.token?.card?.object})
                </span>
                <br />
              </div>
              <div className="col-md-6 col-lg-6 col-sm-12 mb-2">
                <span className="text-secondary"> Expiry Date</span>
                <span className="float-right text-dark">
                  {props && props.user.token?.card?.exp_month}/{" "}
                  {props && props.user.token?.card?.exp_year}
                </span>
                <br />
              </div>
              <div className="col-md-6 col-lg-6 col-sm-12 mb-2">
                <span className="text-secondary"> Last 4 </span>
                <span className="float-right text-dark">
                  ....{props && props.user.token?.card?.last4}
                </span>
                <br />
              </div>
              <div className="col-md-6 col-lg-6 col-sm-12 mb-2">
                <span className="text-secondary"> Type </span>
                <span className="float-right text-dark">
                  {props && props.user.token?.type}
                </span>

                <br />
              </div>
              <div className="col-md-6 col-lg-6 col-sm-12 mb-2">
                <span className="text-secondary"> country </span>{" "}
                <span className="float-right text-dark">
                  {props && props.user.token?.card?.country}
                </span>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <ActionButtons {...props} nextStep={validate4} />
    </div>
  );
};
const Sample = () => {
  const [stepWizard, setStepWizard] = useState(null);
  const [user, setUser] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [isLanguageSelected, setIsLanguageSelected] = useState(false);
  const [languageSelected, setLanguageSelected] = useState("");

  const assignStepWizard = (instance) => {
    setStepWizard(instance);
  };

  const assignUser = (val) => {
    setUser((user) => ({
      ...user,
      ...val,
    }));
  };
  const assignCard = (val) => {
    console.log(val);
  };

  const styleConfig = {
    completedBgColor: "#ea8f60",
    activeBgColor: "#4cabd4",
    inactiveBgColor: "#161414f0",
  };

  const handleStepChange = (e) => {
    console.log(e);
    setActiveStep(e.activeStep - 1);
  };

  const handleComplete = () => {
    alert("You r done. TQ");
  };

  return (
    <>
      {!isLanguageSelected && (
        <div
          style={{ textAlign: "center", padding: "20px", marginTop: "180px" }}
        >
          <h4>Choose Your Language / Choisissez Votre Langue</h4>
          <p>
            Please select your preferred language for using the application. /
            Veuillez sélectionner la langue de votre choix pour utiliser
            l'application.
          </p>
          <ButtonGroup vertical style={{ display: "block" }}>
            <BootstrapButton
              onClick={() => {
                setIsLanguageSelected(true);
                setLanguageSelected("en");
              }}
              style={{ width: "100%", marginBottom: "10px" }}
            >
              English / Anglais
            </BootstrapButton>
            <BootstrapButton
              onClick={() => {
                setIsLanguageSelected(true);
                setLanguageSelected("fr");
              }}
              style={{ width: "100%" }}
            >
              French / Français
            </BootstrapButton>
          </ButtonGroup>
        </div>
      )}
      {isLanguageSelected && (
        <div>
          <Stepper
            activeStep={activeStep}
            activeColor="step-costom"
            styleConfig={styleConfig}
          >
            <Step label="Brokrage Detail" stepClassName="#ea8f60" />
            <Step label="User Detail" />
            <Step label="Terms and Condition" />
            <Step label="Card Detail" />
            <Step label="Payment Detail" />
          </Stepper>
          {/* NOTE: IMPORTANT !! StepWizard must contains at least 2 children components, else got error */}
          <StepWizard
            instance={assignStepWizard}
            onStepChange={handleStepChange}
          >
            <One
              languageSelected={languageSelected}
              userCallback={assignUser}
            />
            <Two
              languageSelected={languageSelected}
              user={user}
              userCallback={assignUser}
            />
            <Three
              languageSelected={languageSelected}
              user={user}
              userCallback={assignUser}
            />
            <Four
              languageSelected={languageSelected}
              user={user}
              userCallback={assignCard}
              userCallback={assignUser}
              // completeCallback={handleComplete}
            />
            <Five
              languageSelected={languageSelected}
              user={user}
              userCallback={assignCard}
              completeCallback={handleComplete}
            />
          </StepWizard>
        </div>
      )}
    </>
  );
};

export default Sample;
